import { GitHub, LinkedIn, Phone, Email } from '@mui/icons-material';
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__content}>
        <div className={styles.footer__section}>
          <h4>Kontakt</h4>
          <div className={styles.footer__contact}>
            <a href="tel:+48692683155">
              <Phone /> +48 692 683 155
            </a>
            <a href="mailto:dariuszszymczak.work@gmail.com">
              <Email /> dariuszszymczak.work@gmail.com
            </a>
          </div>
        </div>

        <div className={styles.footer__section}>
          <h4>Social Media</h4>
          <div className={styles.footer__social}>
            <a href="https://www.github.com/DariuszSzymczak" target="_blank" rel="noopener noreferrer">
              <GitHub /> GitHub
            </a>
            <a href="https://www.linkedin.com/in/dariuszszymczak/" target="_blank" rel="noopener noreferrer">
              <LinkedIn /> LinkedIn
            </a>
          </div>
        </div>

        <div className={styles.footer__section}>
          <h4>O mnie</h4>
          <p>Full-Stack Developer & One Man Army. Tworzę kompleksowe, nowoczesne i responsywne aplikacje internetowe od A do Z.</p>
        </div>
      </div>
      
      <div className={styles.footer__bottom}>
        <p>&copy; 2024 Dariusz Szymczak. Wszystkie prawa zastrzeżone.</p>
      </div>
    </footer>
  );
};

export default Footer; 